module.exports = __webpack_public_path__ + "static/img/shouxin.479e22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/shouxin.png
// module id = DS4J
// module chunks = 70